import ButtonBarSkeleton from './_button-bar-skeleton.js'
import ScrollPane from './_scroll-pane.js'
import LoaderSuspense from './_loader-suspense.js'
import ButtonBar from './_button-bar.js'

export default {
  name: 'FiltersBar',
  values: {
    defaultNamingSchemaForDayFilters: 'EEE d',
    topMenuSkeleton: {
      configSet: ButtonBarSkeleton,
      configValues: {
        container: {
          style: {
            flexWrap: 'nowrap',
            padding: '8px',
          },
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'x',
      },
    },
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {},
    },
    filter: {
      configSet: ButtonBar,
      configValues: {
        button: {
          selected: {
            style: {
              base: {
                minHeight: '40px',
                minWidth: '64px',
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: 'auto',
              },
            },
          },
          unselected: {
            style: {
              base: {
                minHeight: '40px',
                minWidth: '64px',
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: 'auto',
              },
            },
          },
        },
        container: {
          style: {
            padding: '0px',
          },
        },
        buttonWrapper: {
          style: {
            flexWrap: 'nowrap',
            width: 'max-content',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
